/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    object, shape, string, arrayOf,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { useUIDSeed } from 'react-uid';
import ResponsiveImage from '../../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';
import LinkOrATag from '../../GraphqlCommonComponents/LinkOrATag/LinkOrATag';

const styles = (theme)  => ({
    block: {
        border: `1px solid ${theme.palette.grey7}`,
        margin: '10px 0',
        '& img': {
            width: '100%',
            display: 'block',
        },
        [theme.breakpoints.down(600)]: {
            maxWidth: '80%',
            margin: '10px auto',
        },
    },
    article: {
        margin: 'auto',
        width: '100%',
        maxWidth: 1080,
        textAlign: 'center',
        '& a': {
            textDecoration: 'none',
            color: theme.palette.common?.black,
        },
        [theme.breakpoints.down(600)]: {
            '& h1': {
                margin: 26,
                fontSize: 16,
            },
        },
    },
    articleBox: {
        padding: '0px 25px 0',
        '& img': {
            width: '100%',
            display: 'block',
            maxHeight: 170,
            minHeight: 170,
            borderRadius: 10,
        },
        [theme.breakpoints.down(600)]: {
            '& img': {
                maxHeight: 115,
                minHeight: 115,
                borderRadius: 5,
            },
            padding: '0px 30px 0',
        },
        '& p': {
            margin: 0,
        },
    },
});

const ArticleBlock = ({ data, classes, brand }) => {
    const seed = useUIDSeed();
    const { header, article } = data;
    return (
        <>
            <Grid item xs={12} className={classes.block}>
                <Grid container className={classes.article}>
                    <Grid item xs={12}><h1>{header}</h1></Grid>
                    {
                        article.map((art) => {
                            const { image: { url, description }, link: { title, href } } = art;
                            let link = href || '';

                            if (href?.substring(0, 4) === '/blog' || href?.includes?.('/articles')) {
                                link = `https://www.${brand?.domain}.com${href}`;
                            }
                            return (
                                <Grid key={seed(art)} item xs={12} sm={4}>
                                    <div className={classes.articleBox}>
                                        <LinkOrATag href={link}>
                                            <ResponsiveImage className={classes.bannerImage} path={url} alt={description || 'Article Image'} />
                                        </LinkOrATag>
                                    </div>
                                    <LinkOrATag href={link}>
                                        <p> {title}</p>
                                    </LinkOrATag>
                                </Grid>
                            );
                        })
                    }
                </Grid>
            </Grid>
        </>
    );
};

ArticleBlock.propTypes = {
    classes: object.isRequired,
    brand: shape({
        'domain-name': string,
    }).isRequired,
    data: shape({
        header: string,
        article: arrayOf(shape({
            image: shape({
                url: string.isRequired,
                filename: string.isRequired,
            }).isRequired,
            link: shape({
                title: string.isRequired,
                href: string.isRequired,
            }).isRequired,
        })),
    }).isRequired,

};
export default withStyles(styles)(ArticleBlock);
